import script from "./PositionsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionsForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__